<div class="nt-carousel carousel-wrap carousel-fill-height nt-flex onboarding-carousel">
  <header>
    <h1><img src="assets/svg/icentral_logo.svg" alt="iCentral"></h1>
  </header>
  <!--
    autoplayInterval is the input p-carousel reads. The interval used to live in an ngx-bootstrap
    CarouselConfig provider on this component, which PrimeNG never looks at, so the slides stopped
    rotating when 3a8ca37d (2025-12-18, "onboarding page branding") moved this template from
    ngx-bootstrap to PrimeNG and left the provider behind. Measured on nt-dev before this change: the
    active indicator did not move in 19 seconds. The provider is gone from the component now; it was
    the app's last reference to ngx-bootstrap/carousel.

    The rotation holds while a visitor is reading: pointerenter/pointerleave for the mouse, focusin/
    focusout for the keyboard. WCAG 2.2.2 wants a way to stop content that moves on its own for more
    than five seconds beside other content, and the sign-in form is right next to it.
  -->
  <p-carousel
    [value]="slides()"
    [circular]="!noWrapSlides"
    [autoplayInterval]="autoplayIntervalMs"
    (pointerenter)="pauseAutoplay()"
    (pointerleave)="resumeAutoplay()"
    (focusin)="pauseAutoplay()"
    (focusout)="resumeAutoplay()"
    (onPage)="onPageChanged()"
    [numVisible]="1"
    [numScroll]="1"
    [showIndicators]="showIndicator"
    [showNavigators]="false"
    class="nt-flex-col nt-flex-fill-height auth-carousel"
    >
    <ng-template #item let-slide let-index="index">
      <div class="slide-wrap nt-fill-height" [id]="index" [class]="slide.class">
        <div
          class="slide-bg nt-flex"
          [style.background-image]="slide.bgImg ? 'url(' + slide.bgImg + ')' : null"
          >
          <article class="article">
            <div class="slide-img">
              @if (slide.img2) {
                <!--
                  priority: the browser reports this one as the LCP element on /login (NG02955 if it
                  is not marked), because every slide is in the DOM and this is the largest painted
                  image. It only exists on the third slide, so nothing else gets preloaded.
                -->
                <img [ngSrc]="slide.img2" [width]="slide.img2Width" [height]="slide.img2Height"
                     priority alt="">
              }
              <!--
                ngSrc with the slide's own intrinsic size: NgOptimizedImage needs width and height to
                reserve the right aspect ratio while the file loads, and the three slides differ, so the
                numbers live on the slide rather than in the markup. CSS still sets the rendered size.

                srcset stays a plain attribute. ngSrcset would only warn here (NG2963), because it needs an
                image loader and this app uses the default one, and the 1x/2x pair is already correct.

                priority is set on slide three's second image above, not here: the browser measures that one
                as the LCP element, and marking all three would preload images nobody has scrolled to.

                loading="eager" because these images used to load eagerly and NgOptimizedImage defaults to
                lazy. Two reasons to keep the old behaviour: the carousel rotates on its own, so a lazy slide
                would arrive after the user is already looking at it, and the visual harness waits for every
                document.images entry to complete before it screenshots, so a lazily loaded off-screen slide
                hangs the gate until its timeout (build 29148, all eight auth screens at 2m each).
              -->
              <img [ngSrc]="slide.img" [width]="slide.imgWidth" [height]="slide.imgHeight"
                   loading="eager" [attr.srcset]="slide.srcset || null" alt="image slide" />
            </div>
            <div class="content-wrap">
              @if (slide.qrCode != null) {
                <div>
                  <ic-icon-svg
                    [iconName]="slide.qrCode"
                    class="qr-code-wrap"
                  ></ic-icon-svg>
                </div>
              }
              <h4 class="slide-title" [innerHTML]="slide.title"></h4>
              <p class="slide-content">{{ slide.content }}</p>
            </div>
          </article>
        </div>
      </div>
    </ng-template>
  </p-carousel>
</div>

